import type from './MultiProductSelect.type';

const initialState = {
  allProductDetails: [],
  allTestingLibraries: [],
  allBomCompoList: [],
  suppliers: [],
  allProductExchnageRate: [],

  productDetails: {},
  isProductArchived: false,
  productColours: [],
  productSizes: [],
  productLengths: [],
  productExchnageRate: null,
  TestingLibraries: [],
  bomCompoList: [],
  firstSelection: {
    supplierId: null,
    currency: null,
    incoterms: null,
    reference: '',
    shipmentMethod: null,
  },
  preProductTemplate: null,
  firstSelectionInvite: {
    commentMsg: '',
    productCostCommentModal: false,
  },
  switchSelection: {
    averageCostingActive: false,
    detailedCostingActive: false,
    isBreakdown: false,
  },
};

const getExchangeRateList = (devOrder, exchangeRateList) => {
  if (devOrder.seasonId && devOrder.year) {
    const exchangeRate = exchangeRateList.find((item) => item.seasonId === devOrder.seasonId && item.year === devOrder.year);
    return exchangeRate || null;
  }
  return null;
};

const getBOMOrTestingList = (devOrderId, list) => {
  return list.filter((item) => item.devOrderId === devOrderId);
};

const MultiProductSelectReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.SET_ALL_PRODUCT_DETAILS:
      return {
        ...state,
        allProductDetails: action.payload.prodInfo,
        suppliers: action.payload.supplierInfo,
      };
    case type.SET_ALL_PRODUCT_TESTING_LIBS:
      return {
        ...state,
        allTestingLibraries: action.payload,
      };
    case type.SET_ALL_PRODUCT_BOM_COMPS:
      return {
        ...state,
        allBomCompoList: action.payload,
      };
    case type.SET_ALL_EXCHANGE_RATES:
      return {
        ...state,
        allProductExchnageRate: action.payload,
      };
    case type.SET_CURRENT_PRODUCT_DATA:
      return {
        ...state,
        productDetails: action.payload,
        isProductArchived: action.payload.isArchived || action.payload.isDeleted,
        productColours: action.payload.colourLibraries || [],
        productSizes: action.payload.sizeRanges || [],
        productLengths: action.payload.legLengths || [],
        productExchnageRate: getExchangeRateList(action.payload, state.allProductExchnageRate),
        TestingLibraries: getBOMOrTestingList(action.payload?._id, state.allTestingLibraries),
        bomCompoList: getBOMOrTestingList(action.payload?._id, state.allBomCompoList),
      };
    case type.SET_FIRST_SELECTION_DATA:
      if (action.payload.type === 'temp') {
        return {
          ...state,
          preProductTemplate: action.payload.data.productTemplate,
        };
      }
      if (action.payload.type === 'invite') {
        return {
          ...state,
          firstSelectionInvite: action.payload.data,
        };
      }
      if (action.payload.type === 'switch') {
        return {
          ...state,
          switchSelection: action.payload.data,
        };
      }
      return {
        ...state,
        firstSelection: action.payload.data,
      };

    case type.CLEAR_REDUCER_MULTIPLE_COSTING:
      return {
        ...initialState,
        firstSelection: {
          supplierId: null,
          currency: null,
          incoterms: null,
          reference: '',
          shipmentMethod: null,
        },
      };
    default:
      return state;
  }
};

export default MultiProductSelectReducer;
